export const PINNED_DASHBOARDS_NS = 'components/PinnedDashboards';

export const i18n = {
  en: {
    containerTitle: 'Performance',
    customise: {
      buttonTitle: 'Customise',
    },
    dashboardActions: {
      navigateTo: 'Navigate to {{ reportName }}',
      removeFromHome: 'Remove from Home',
      deleteConfirm: 'Are you sure to remove dashboard from the Home page?',
    },
    noItems: 'No pinned dashboards',
    genericError: 'Something went wrong',
    modal: {
      title: '{{ label }} data',
    },
  },
};
